module.exports = __webpack_public_path__ + "img/期刊匹配：国内核心期刊.80a415b4.png";